import Label from "@weave-design/label";
import { AuxiliaryPropertyEditorControl } from "./auxiliaryPropertyEditorControl";
import "./inputs.css";

type Props = {
    title?: string;
    children?: React.ReactNode;
    auxiliaryControl?: AuxiliaryPropertyEditorControl;
    className?: string;
};

export const PropertyEditor = ({ title, children, auxiliaryControl, className }: Props) => {
    const noTitleStyle = !title ? " property-input-no-title" : "";

    const inputValueContainerStyles: React.CSSProperties = {};

    if (auxiliaryControl) {
        inputValueContainerStyles.width = `calc(75% - ${auxiliaryControl.width}px)`;
    }

    const containerClassName = className ? `property-input-container ${className}` : "property-input-container";

    return (
        <div className={containerClassName}>
            {title && (
                <div className="property-input-title-container">
                    <Label>{title}</Label>
                </div>
            )}
            <div className={`property-input-value-container${noTitleStyle}`} style={inputValueContainerStyles}>
                {children}
            </div>
            {auxiliaryControl && <div style={auxiliaryControl.containerStyles}>{auxiliaryControl.control}</div>}
        </div>
    );
};
